import { gql } from '@apollo/client';

export const IS_LOADING = gql`
  query isLoading {
    loading @client
  }
`;

export const IS_LOGGED_IN = gql`
  query isLoggedIn {
    isLoggedIn @client
  }
`;

export const GET_TOKEN = gql`
  query getToken {
    token @client
    isLoggedIn @client
    netId @client
    role @client
    loading @client
    loginLoading @client
  }
`;

export const REFRESH_TOKEN = gql`
  mutation refreshToken($init: Boolean) {
    refreshToken(init: $init) {
      token
      me {
        netId
        role
      }
    }
  }
`;

export const INIT_REFRESH_TOKEN = gql`
  mutation initRefreshToken {
    refreshToken {
      token
      me {
        netId
        role
      }
    }
  }
`;

export const GET_ME = gql`
  query me {
    me {
      netId
      role
    }
  }
`;

export const DELETE_REFRESH_TOKEN = gql`
  mutation DELETE_REFRESHTOKEN {
    deleteRefreshToken
  }
`;

export const LOGIN = gql`
  mutation LOGIN($token: String!) {
    login(token: $token) {
      token
      me {
        netId
        id
        role
      }
    }
  }
`;
